 
import React from "react";

// reactstrap components
import { Container, Row, Col } from "reactstrap";

// core components

function SectionDarkTop() {
  return (
    <>
      <div className="section section-dark"> 
        <Container>
          <Row>
            <Col className="ml-auto mr-auto text-center" md="8">
              <h2 className="title">Forged in hellfire to be solid as a diamond, a New Way to thing about De-FI</h2>
              <p className="description">
                With our small consumption rate, you can hold and trade without worrying about losing money. we understand that time is our ally. because nothing escapes the chaos 
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default SectionDarkTop; 
